// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"16ea347e","453":"78d4914b","644":"c86eede6"}[chunkId] + ".chunk.js";
};